import $ from "jquery"
import modals from "bootstrap/js/dist/modal"
import CryptoJS from "crypto-js";
import i18n from '@/i18n'
import { storage } from '@/assets/js/firebase';
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
// console.log('storage->',storage) //gs://dcp-test-186fb.appspot.com/
const storageRef = ref(storage, 'some-child');
// console.log('storageRef->',storageRef)
class shareds {
    //物件建立時產生
    constructor() {
        this.weekdays = ['日', '一', '二', '三', '四', '五', '六'];
    }

    imagePath(image) {
        return require(`@/assets/image/${i18n.global.locale.value}/${image}`)
    }

    toBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file); // 會變成 base64: data:xxx;base64,xxxxx
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    //設定subtitle文字內容
    setText(data = {}) {
        $(data.tag).text(data.text)
    }
    //處理GCP檔案上傳
    // 處理 GCP 檔案上傳（非同步）
    async uploadFileToGCPHandle(parameter, file) {
        try {
            const metadata = { contentType: file.type };
            const url = `${process.env.VUE_APP_GCP_BUCKET}/${parameter.path}${parameter.filename}`;
            const storageRef = ref(storage, url);
            // 創建可監控的上傳任務
            const uploadTask = uploadBytesResumable(storageRef, file, metadata);
            // 監聽上傳進度
            const uploadPromise = new Promise((resolve) => {
                uploadTask.on(
                    'state_changed',
                    (snapshot) => {
                        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        // console.log(`Upload is ${progress}% done`);
                        if (parameter.progress) parameter.progress(progress);
                    }, (error) => {
                        console.error('Upload failed:', error.code);
                        if (parameter.error) parameter.error(error);
                        resolve(null);
                    }, async () => {
                        try {
                            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                            // console.log('File available at', downloadURL);
                            if (parameter.success) parameter.success(downloadURL);
                            resolve(downloadURL);
                        } catch (error) {
                            // console.error('Error getting download URL:', error);
                            resolve(null);
                        }
                    }
                );
            });

            return await uploadPromise; // 等待上傳完成後返回結果

        } catch (error) {
            console.error('Upload error:', error);
            if (parameter.error) parameter.error(error);
            throw error;
        }
    }

    //處理gcp檔案刪除
    async deleteFileToGCPHandle(parameter) {
        return new Promise((resolve) => {
            try {
                const url = `${process.env.VUE_APP_GCP_BUCKET}/${parameter.path}`
                const desertRef = ref(storage, url + parameter.filename);
                deleteObject(desertRef).then((res) => {
                    // File deleted successfully
                    // console.log('File deleted successfully : ' , res)
                    resolve({
                        code: 0,
                        msg: 'File deleted successfully : '
                    })
                }).catch((error) => {
                    // console.log('Uh-oh, an error occurred:',error)
                    // Uh-oh, an error occurred!
                    resolve({
                        code: 1,
                        msg: 'Uh-oh, an error occurred:', error
                    })
                })

            } catch (error) {
                resolve({
                    code: 1,
                    msg: error
                })
                throw error;
            }
        })


    }


    //顯示全畫面讀取
    LoadingStatus(status) {
        if (status == 'show') {
            $('.full-seucce').css('display', 'flex')
        } else if (status == 'hide') {
            $('.full-seucce').css('display', 'none')
        }
    }

    /**********
     * 檢查物件是否不存在
     * obj : any object
     */
    isEmpty = (obj) => {
        if (
            typeof obj == 'undefined'
            || obj == null
            || obj.length <= 0
        ) {
            return true;
        }
        return false;
    }

    //初始化牙齒陣列
    initTeethAry(teeth = [], teeth_group = []) {
        // console.log(`initTeethAry=` ,teeth, teeth_group)
        let ary = {}
        for (let index = 18; index >= 11; --index) {
            ary[index] = {
                name: index,
                value: 0,
                class: ''
            }
        }
        for (let index = 21; index <= 28; index++) {
            ary[index] = {
                name: index,
                value: 0,
                class: ''
            }
        }
        for (let index = 38; index >= 31; --index) {
            ary[index] = {
                name: index,
                value: 0,
                class: ''
            }
        }
        for (let index = 41; index <= 48; index++) {
            ary[index] = {
                name: index,
                value: 0,
                class: ''
            }
        }

        // console.log(`init ary=` , ary)

        for (let index = 0; index < teeth.length; index++) {
            const teethItem = teeth[index];
            if (!ary[teethItem]) continue
            ary[teethItem].value = 1
            ary[teethItem].class = 'select'
        }

        for (let i = 0; i < teeth_group.length; i++) {
            const groupItem = teeth_group[i];
            for (let n = 0; n < groupItem.length; n++) {
                const teethItem = groupItem[n];
                if (!ary[teethItem]) continue
                ary[teethItem].value = 2
                ary[teethItem].class = 'link'
            }
        }

        // console.log(`set ary=` , ary)

        return ary
    }
    //初始化日期格式
    initDataStr(dateObj) {
        let DateTime = ''
        DateTime = dateObj.getFullYear() + '/' + (dateObj.getMonth() + 1).toString().padStart(2, '0') + '/' + dateObj.getDate().toString().padStart(2, '0')
        return DateTime
    }
    //呼叫顯示popup視窗
    initModal(target) {
        const modal = new modals(document.getElementById(target));
        return modal
    }
    showModal(modal) {
        modal.show();
    }
    //關閉popup視窗
    hideModal(modal) {
        modal.hide();
    }
    //初始化狀態陣列
    orderOrderStatus() {

        let status = []

        status[0] = "Order Creating"; //'訂單建立中'
        status[1] = "Order Open for Matching"; //'訂單開放媒合'
        status[2] = "Matched, Pending Confirmation"; //'訂單已媒合未確認'
        status[3] = "Impression Shipping"; //'訂單齒模寄送'
        status[4] = "Waiting for Lab Acceptance"; //'訂單等待牙技所接受'
        status[5] = "Order Confirmed"; //'訂單已確認'

        status[11] = "In Progress"; //'訂單執行中'
        status[12] = "In Progress"; //'訂單執行中'
        status[13] = "Midway Confirmation"; //'訂單製作中途確認'
        status[14] = "In Progress"; //'訂單執行中'
        status[15] = "Shipping Completed Prosthesis"; //'訂單製作完成寄送中'
        status[16] = "Awaiting Clinic Confirmation"; //'訂單製作完成待診所確認'

        status[80] = "Redo Confirmation"; //'訂單執行中'
        status[81] = "order edit Confirmation"; //'訂單執行中'
        status[82] = "order edit Confirmation"; //'訂單執行中'

        status[91] = "Lab Canceled"; //'訂單牙技所確認取消'
        status[92] = "Lab reject"; //'訂單牙技所拒絕訂單'
        status[98] = "Order Canceled"; //'訂單取消'
        status[99] = "Order Completed"; //'訂單完成'

        status[100] = "Matching Failed"; //'媒合失敗'

        return status
    }

    orderOrderStatusIcon() {
        let status = []

        status[0] = "fas fa-fw fa-file-signature"; //'訂單建立中'
        status[1] = "fas fa-fw fa-users"; //'訂單開放媒合'
        status[2] = "fas fa-fw fa-comments"; //'訂單已媒合未確認'
        status[3] = "fas fa-fw fa-truck"; //'訂單齒模寄送'
        status[4] = "fas fa-fw fa-hands-helping"; //'訂單等待牙技所接受'
        status[5] = "fas fa-fw fa-check"; //'訂單已確認'

        status[11] = "fas fa-fw fa-pencil-ruler"; //'訂單執行中'
        status[12] = "fas fa-fw fa-pencil-ruler"; //'訂單執行中'
        status[13] = "fas fa-fw fa-user-check"; //'訂單製作中途確認'
        status[14] = "fas fa-fw fa-pencil-ruler"; //'訂單執行中'
        status[15] = "fas fa-fw fa-shipping-fast"; //'訂單製作完成寄送中'
        status[16] = "fas fa-fw fa-check-double"; //'訂單製作完成待診所確認'

        status[80] = "fas fa-fw fa-redo"; //'訂單執行中'
        status[81] = "fas fa-fw fa-redo"; //'訂單執行中'
        status[82] = "fas fa-fw fa-redo"; //'訂單執行中'

        status[91] = "fas fa-fw fa-ban"; //'訂單牙技所確認取消'
        status[92] = "fas fa-fw fa-ban"; //'訂單牙技所拒絕訂單'
        status[98] = "fas fa-fw fa-ban"; //'訂單取消'
        status[99] = "fas fa-fw fa-check"; //'訂單完成'

        status[100] = "fas fa-fw fa-ban"; //'媒合失敗'

        return status
    }
    //轉換狀態字串
    getOrderStatusString(index) {
        let statusAry = this.orderOrderStatus()
        let iconAry = this.orderOrderStatusIcon()
        return {
            label: statusAry[index],
            icon: iconAry[index]
        }
    }
    //轉換訂單部分內容資訊
    getOrderToothContent(teeth = [], teethGroup = []) {
        // 1. 合併陣列、拍平二維陣列、去重、排序
        // 注意：這裡先轉 Set 再轉回 Array 是為了確保唯一性
        let uniqueTeeth = [...new Set([...teeth, ...teethGroup.flat()])].sort((a, b) => a - b);

        if (uniqueTeeth.length === 0) return [];

        // 定義上下顎的完整齒位範圍 (FDI 兩位數標記法)
        const upperRange = [
            11, 12, 13, 14, 15, 16, 17, 18,
            21, 22, 23, 24, 25, 26, 27, 28
        ];
        const lowerRange = [
            31, 32, 33, 34, 35, 36, 37, 38,
            41, 42, 43, 44, 45, 46, 47, 48
        ];

        // 判斷是否包含完整的上顎或下顎
        const hasFullUpper = upperRange.every(t => uniqueTeeth.includes(t));
        const hasFullLower = lowerRange.every(t => uniqueTeeth.includes(t));

        // 邏輯 1: 如果上下顎全都有 -> '全口'
        if (hasFullUpper && hasFullLower) {
            return ['全口'];
        }

        const result = [];

        // 邏輯 2: 處理上顎
        if (hasFullUpper) {
            result.push('上顎');
            // 如果已加入上顎標籤，從 uniqueTeeth 中移除上顎齒位，避免後面重複列出
            uniqueTeeth = uniqueTeeth.filter(t => !upperRange.includes(t));
        }

        // 邏輯 3: 處理下顎
        if (hasFullLower) {
            result.push('下顎');
            // 如果已加入下顎標籤，從 uniqueTeeth 中移除下顎齒位
            uniqueTeeth = uniqueTeeth.filter(t => !lowerRange.includes(t));
        }

        // 邏輯 4: 將剩餘的散落齒位加上 '#' 前綴並加入結果
        // 例如：剩下 [#18, #17] 或 只有部分齒位的情況
        const remainingTeethFormatted = uniqueTeeth.map(t => `#${t}`);

        return [...result, ...remainingTeethFormatted];
    }
    getCrownMaterialOrderContent(crown) {
        let content = []
        if (crown.zirconia === 1) content.push(i18n.global.t('Zirconium Dioxide'))
        if (crown.glass_ceramics === 1) content.push(i18n.global.t('Glass Ceramics'))
        if (crown.composite === 1) content.push(i18n.global.t('Resin'))
        if (crown.other_material === 1) content.push(`${i18n.global.t('other')}：${crown.other_material_name}`)
        return content
    }
    getCrownShapeOrderContent(crown) {
        let content = []
        if (crown.veneer === 1) content.push(i18n.global.t('Patches')) //貼片
        if (crown.cd === 1) content.push(i18n.global.t('Full Crown')) //全冠
        if (crown.inlay === 1) content.push(i18n.global.t('Inlay')) //嵌體
        return content
    }

    getRpdMaterialOrderContent(rpd) {
        const content = []
        return content
    }

    getOrderSendTypeString(type) {
        let srt = ''
        switch (type) { //1=親送 2=貨運 3=寄送
            case 1:
                srt = 'Pick up in person'//'親送'
                break;
            case 2:
                srt = 'Express or freight'//'貨運'
                break;
            case 3:
                srt = '寄送'
                break;
            default:
                break;
        }
        return srt
    }
    //加密
    encryptionUserInfo(data) {
        console.log(data)
        var key = CryptoJS.enc.Utf8.parse("c4e1u12d45e83f78535dkb86bah50f4a");
        var iv = CryptoJS.enc.Utf8.parse("");
        let encrypted = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(JSON.stringify(data)),
            key, {
            iv: iv,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }
        );
        console.log("encrypted=", encrypted.ciphertext.toString(CryptoJS.enc.Base64))
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64)
    }
    encryption() {

    }

    decryption(parameter) {
        const key = CryptoJS.enc.Utf8.parse("c4e1u12d45e83f78535dkb86bah50f4a");
        const decrypt = CryptoJS.AES.decrypt(
            parameter,
            key,
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        return decrypt.toString(CryptoJS.enc.Utf8)
    }
    decryptionUserInfo(data) {
        let userData = JSON.parse(this.decryption(data))
        // userData = this.initDefaultClinic(userData)
        // userData = this.reDecryptionUserToken(userData)
        return userData
    }
    /** 
     * 將整個user資訊傳進去，然後重新處理token將診所資料餵進去，重新生成token
    */
    reDecryptionUserToken(userData) {
        const token = userData.token
        let tokenData = JSON.parse(this.decryption(token))
        // console.log(`tokenData=` , tokenData)
        tokenData.com_id = userData.com_id
        tokenData.com_name = userData.com_name
        tokenData.com_type = userData.com_type
        tokenData.role_id = userData.role_id
        tokenData.role_name = userData.role_name
        userData.token = this.encryptionUserInfo(tokenData)
        return userData
    }

    initDefaultClinic(data) {

        // console.log(`initDefaultClinic******************************`)
        // console.log(`data=` , data)
        //判斷com_id不是-1的話直接跳出
        if (data.com_id !== -1) {
            return data
        }

        let user = data
        user.com_id = data.clinic[0].clinic_id
        user.com_name = data.clinic[0].name
        user.com_type = data.clinic[0].type_id
        user.role_id = data.clinic[0].role_id
        user.role_name = data.clinic[0].role_name

        // console.log(`user=` , user)

        // console.log(`return******************************`)

        return user
    }

    getCompName(compType) { //取得title
        // console.log('getCompName=',compType)
        let titleName = ''
        switch (compType) {
            case 1:
                titleName = '管理後台'
                break;
            case 2:
                titleName = '掛號系統'
                break;
            case 3:
                titleName = '診所'
                break;
            case 4:
                titleName = '牙技所'
                break;
            default:
                break;
        }
        // console.log('titleName=',titleName)
        return titleName
    }

    gotoSystemView(compID) {
        let url = ''
        switch (compID) {
            case 1:
                url = 'http://localhost:3001?token='
                break;
            case 2:
                url = 'http://localhost:3002?token='
                break;
            case 3:
                url = 'http://localhost:3001?token='
                break;
            case 4:
                url = 'http://localhost:3003?token='
                break;
            default:
                break;
        }
        return url
    }

    //換算當地時間
    getLoaclDateTime(dateTime) {
        if (dateTime == null || dateTime == '' || dateTime == -1) {
            return ""
        }
        let timeDate = new Date(dateTime)
        let loaclTime = new Date(timeDate)
        var sy = loaclTime.getFullYear();
        var sm = (loaclTime.getMonth() + 1).toString().padStart(2, '0');
        var sd = loaclTime.getDate().toString().padStart(2, '0');
        var sh = (loaclTime.getHours()).toString().padStart(2, '0');
        var si = (loaclTime.getMinutes()).toString().padStart(2, '0');
        var ss = loaclTime.getSeconds().toString().padStart(2, '0');

        return sy + "-" + sm + "-" + sd + " " + sh + ":" + si + ":" + ss;
    }
    //換算當地時間
    getLoaclDate(dateTime) {
        if (dateTime == null || dateTime == '' || dateTime == -1) {
            return ""
        }
        let timeDate = new Date(dateTime)
        let loaclTime = new Date(timeDate)
        var sy = loaclTime.getFullYear();
        var sm = (loaclTime.getMonth() + 1).toString().padStart(2, '0');
        var sd = loaclTime.getDate().toString().padStart(2, '0');

        return sy + "-" + sm + "-" + sd
    }
    //所有的id管理
    getAccountTitle(status) {
        let status_name = ''
        switch (status) {
            case 1:
                status_name = 'Mr.' //先生
                break;
            case 2:
                status_name = 'Ms.' //小姐
                break;
            default:
                status_name = status
                break;
        }
        return status_name
    }

    getCompanyStatus(status) {
        let status_name = ''
        switch (status) {
            case 1:
                status_name = 'Enable'//'已啟用'
                break;
            case 2:
                status_name = 'Disable' //'已停用'
                break;
            default:
                status_name = status
                break;
        }
        return status_name
    }
    getCompanyType(status) {
        let status_name = ''
        switch (status) {
            case 1:
                status_name = '管理後台'
                break;
            case 2:
                status_name = '掛號系統商'
                break;
            case 3:
                status_name = '診所'
                break
            case 4:
                status_name = '牙技所'
                break;
            default:
                status_name = status
                break;
        }
        return status_name
    }
    getAccountStatus(status) {
        let status_name = ''
        switch (status) {
            case 1:
                status_name = '已啟用'
                break;
            case 2:
                status_name = '已停用'
                break;
            case 3:
                status_name = '等待啟用'
                break;
            case 4:
                status_name = '已逾時'
                break;
            case 5:
                status_name = '自行註冊'
                break;
            default:
                status_name = status
                break;
        }
        return status_name
    }
    getAccountJobTitle(status) {
        let status_name = ''
        switch (status) {
            case 1:
                status_name = '醫師'
                break;
            case 2:
                status_name = '行政'
                break;
            default:
                status_name = status
                break;
        }
        return status_name
    }
    getOrderTypeStr(status) {
        let status_name = ''
        switch (status) {
            case 1:
                status_name = '固定假牙'
                break;
            case 2:
                status_name = '活動假牙'
                break;
            default:
                status_name = status
                break;
        }
        return status_name
    }
    getRoleStatusStr(status) {
        let status_name = ''
        switch (status) {
            case 1:
                status_name = '啟用'
                break;
            case 2:
                status_name = '停用'
                break;
            default:
                status_name = status
                break;
        }
        return status_name
    }


    //設定往後推延日期
    initEndDate(sDate, maxDay) {
        let dateTime = sDate
        let _d = dateTime.setDate(dateTime.getDate() + maxDay)
        return new Date(_d)
    }

    dateFormat(date) {
        var _y = date.getFullYear().toString().padStart(4, '0');
        var _m = (date.getMonth() + 1).toString().padStart(2, '0');
        var _d = date.getDate().toString().padStart(2, '0');
        // console.log('return=',_y+'-'+_m+'-'+_d)
        return _y + '-' + _m + '-' + _d;
    }

    dateTimeFormat(date) {
        var _y = date.getFullYear().toString().padStart(4, '0');
        var _m = (date.getMonth() + 1).toString().padStart(2, '0');
        var _d = date.getDate().toString().padStart(2, '0');
        var _H = date.getHours().toString().padStart(2, '0');
        var _i = date.getMinutes().toString().padStart(2, '0');
        var _s = date.getSeconds().toString().padStart(2, '0');
        // console.log('return=',_y+'-'+_m+'-'+_d)
        return _y + '-' + _m + '-' + _d + ' ' + _H + ':' + _i + ':' + _s;
    }

    dateTimeRomoveFormat(date) {
        var _y = date.getFullYear().toString().padStart(4, '0');
        var _m = (date.getMonth() + 1).toString().padStart(2, '0');
        var _d = date.getDate().toString().padStart(2, '0');
        return _y + '-' + _m + '-' + _d
    }

    initEndDate(sDate, maxDay) {
        let dateTime = sDate
        let _d = dateTime.setDate(dateTime.getDate() + maxDay)
        return new Date(_d)
    }

    //回傳日期 yyyy:mm:dd
    getCurrentDate() {
        //開發時要調用這個設定
        const setting = localStorage.getItem('wildone_dev_setting')
        const date = setting ? JSON.parse(setting).date : null
        if (date) {
            return date
        }

        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }
    //回傳日期 yyyy:mm:dd hh:ii:ss
    getCurrentDateTime() {

        //開發時要調用這個設定
        const setting = localStorage.getItem('wildone_dev_setting')
        const date = setting ? JSON.parse(setting).date : null
        const time = setting ? JSON.parse(setting).time : null
        if (date && time) {
            return `${date} ${time}`
        }

        const now = new Date();

        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    //回傳日期 hh:ii:ss
    getCurrentForTime() {
        //開發時要調用這個設定
        const setting = localStorage.getItem('wildone_dev_setting')
        const date = setting ? JSON.parse(setting).date : null
        const time = setting ? JSON.parse(setting).time : null
        if (date && time) {
            return `${date} ${time}`
        }

        const now = new Date();

        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        return `${hours}:${minutes}:${seconds}`;
    }

    calculateDate(startDate, daysToAdd, excludeWeekends = false) {
        const date = new Date(startDate);
        if (isNaN(date.getTime())) {
            throw new Error('Invalid date format. Expected yyyy-mm-dd.');
        }

        let daysProcessed = 0;
        const step = daysToAdd >= 0 ? 1 : -1; // 正數往前推，負數往回推
        const targetDays = Math.abs(daysToAdd);

        while (daysProcessed < targetDays) {
            date.setDate(date.getDate() + step);
            if (!excludeWeekends || (date.getDay() !== 0 && date.getDay() !== 6)) {
                daysProcessed++;
            }
        }

        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');

        return `${yyyy}-${mm}-${dd}`;
    }


    formatIosDate(isoDate) {

        if (
            isoDate == undefined ||
            isoDate == null ||
            isoDate == ""
        ) {
            return ''
        }

        const date = new Date(isoDate);

        // 提取 UTC 時間部分
        const year = date.getUTCFullYear(); // 使用 getUTC 方法，保持 UTC 時間
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // 使用 getUTCMonth() 來避免本地時區的影響
        const day = String(date.getUTCDate()).padStart(2, '0'); // 使用 getUTCDate() 來避免本地時區的影響

        // 返回格式化的日期
        return `${year}-${month}-${day}`;
    }

    formatIosDateTime(isoDate) {
        if (
            isoDate == undefined ||
            isoDate == null ||
            isoDate == ""
        ) {
            return ''
        }
        const date = new Date(isoDate);
        // 提取日期部分
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        // 提取時間部分
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    }

    formatDateByDate(date, format) {
        // 假設輸入日期是 'yyyy-mm-dd' 格式
        const regex = /^(\d{4})-(\d{2})-(\d{2})$/;
        const match = date.match(regex);

        if (!match) {
            console.error('Invalid date format:', date);
            return 'Invalid date';
        }

        const [_, year, month, day] = match;

        // 使用 Date 物件來計算星期幾
        const d = new Date(`${year}-${month}-${day}`);
        if (isNaN(d.getTime())) {
            console.error('Invalid date:', date);
            return 'Invalid date';
        }

        // 根據格式返回對應部分
        switch (format) {
            case 'yyyy':
                return year;
            case 'mm':
                return month;
            case 'dd':
                return day;
            case 'day':
                return this.weekdays[d.getDay()]; // 返回星期幾
            default:
                return `${year}-${month}-${day}`; // 默認返回完整日期
        }
    }

    getDentureDataSingleTeeth(teeth = [], dentureTeeth = []) {
        let teethList = []
        for (let index = 0; index < teeth.length; index++) {
            const teethIndex = dentureTeeth.findIndex(item => item === teeth[index]);
            if (teethIndex !== -1) {
                teethList.push(teeth[index])
            }
        }
        return teethList
    }

    getDentureDataGroupTeeth(teeth = [], dentureGroupTeeth = []) {
        let groupList = []
        for (let i = 0; i < dentureGroupTeeth.length; i++) {
            const group = dentureGroupTeeth[i]
            let Ary = []
            for (let n = 0; n < group.length; n++) {
                const findIndex = teeth.findIndex(item => item === group[n])
                if (findIndex !== -1) {
                    Ary.push(teeth[findIndex])
                }
            }
            if (Ary.length > 0) {
                groupList.push(Ary)
            }

        }
        return groupList
    }

    singleTeeth(teethData) {
        return Object.entries(teethData)
            .filter(([key, value]) => value.class === "select") // 篩選符合條件的項目
            .map(([key, value]) => value.name); // 只取 value.index，轉成陣列
    }
    linkTeeth(teethData) { //處理連冠
        const linkedIndexes = Object.entries(teethData)
            .filter(([key, value]) => value.class === "link") // 只保留 class 為 "link" 的項目
            .map(([key, value]) => value.name); // 只取 index

        return this.cutGroupTeeth(linkedIndexes)
    }
    cutGroupTeeth(groupTeeth) {
        let Uteeth = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28] //初始化上顎排隊陣列
        let Lteeth = [38, 37, 36, 35, 34, 33, 32, 31, 41, 42, 43, 44, 45, 46, 47, 48] //初始化下顎排隊陣列

        const group = [];

        const segmentTeeth = (teethList) => {
            const result = [];
            let tempGroup = [];

            teethList.forEach(tooth => {
                if (groupTeeth.includes(tooth)) {
                    tempGroup.push(tooth);
                } else if (tempGroup.length > 0) {
                    result.push(tempGroup);
                    tempGroup = [];
                }
            });

            if (tempGroup.length > 0) result.push(tempGroup); // 處理最後一組

            return result;
        };

        group.push(...segmentTeeth(Uteeth));
        group.push(...segmentTeeth(Lteeth));

        return group;
    }

    // cutGroupTeeth(groupTeeth){ //分割連冠群組
    //     console.log('cutGroupTeeth')
    //     let Uteeth = [18,17,16,15,14,13,12,11,21,22,23,24,25,26,27,28] //初始化上顎排隊陣列
    //     let Lteeth = [38,37,36,35,34,33,32,31,41,42,43,44,45,46,47,48] //初始化下顎排隊陣列
    //     //處理上顎的部分
    //     let group = []
    //     let Uary = []
    //     for (let i = 0; i < Uteeth.length; i++) {
    //         // console.log(Uteeth[i],groupTeeth.indexOf(Uteeth[i].toString(),0))
    //         if ( groupTeeth.indexOf(Uteeth[i].toString(),0) > -1 ){
    //             Uary.push(Uteeth[i].toString())
    //         }else{
    //             if ( Uary.length > 0 ){
    //                 group.push(Uary)
    //             }
    //             Uary = []
    //         }
    //     }
    //     if ( Uary.length > 0 ){
    //         group.push(Uary)
    //     }
    //     //處理下顎部分
    //     let Lary = []
    //     for (let i = 0; i < Lteeth.length; i++) {
    //         // console.log(Lteeth[i],groupTeeth.indexOf(Lteeth[i].toString(),0))
    //         if ( groupTeeth.indexOf(Lteeth[i].toString(),0) > -1 ){
    //             Lary.push(Lteeth[i].toString())
    //         }else{
    //             if ( Lary.length > 0 ){
    //                 group.push(Lary)
    //             }
    //             Lary = []
    //         }
    //     }
    //     if ( Lary.length > 0 ){
    //         group.push(Lary)
    //     }
    //     return group
    // }


    /**
     * 計算指定日期與今天的天數差。
     * @param {string} dateString - yyyy-mm-dd 格式的日期字串
     * @param {boolean} excludeWeekends - true: 排除週末只計算工作日；false: 計算所有天數
     * @returns {number} 相差天數（正整數）
     */
    getDaysDifference(dateString, excludeWeekends = false) {
        // 1. 解析輸入字串為「本地時區」的午夜時間
        const [y, m, d] = dateString.split('-').map(Number);
        const inputDate = new Date(y, m - 1, d);

        // 2. 取得今天午夜
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        // 3. 計算毫秒差並轉成整天差（絕對值）
        const msPerDay = 24 * 60 * 60 * 1000;
        const diffMs = Math.abs(today - inputDate);
        const totalDays = Math.floor(diffMs / msPerDay);

        if (!excludeWeekends) {
            // 不排除週末，直接回傳整天差
            return totalDays;
        }

        // 4. 排除週末的計算：只計算週一～週五
        let businessDays = 0;
        // 決定從較早的日期開始，往後逐天檢查
        const start = inputDate < today ? inputDate : today;
        const end = inputDate < today ? today : inputDate;
        const cursor = new Date(start);

        while (true) {
            cursor.setDate(cursor.getDate() + 1);
            if (cursor > end) break;
            const day = cursor.getDay();
            if (day !== 0 && day !== 6) {
                businessDays++;
            }
        }

        return businessDays;
    }

}
export default shareds